// Function for svg sprite
function requireAll(r) {
    r.keys().forEach(r);
}
requireAll(require.context('../images/sprite-images/', true, /\.svg$/));


//Modification comments 
const commentModerations = document.querySelectorAll('.comment-awaiting-moderation');

commentModerations.forEach(commentModeration => {
    commentModeration.parentElement.classList.add('comment-body--moderation');
})

// Calcul width 100vw sans barre overflow du navigateur, dans le css on a donc width: calc(var(--vw, 1vw) * 100);
function setVw() {
    let vw = document.documentElement.clientWidth / 100;
    document.documentElement.style.setProperty('--vw', `${vw}px`);
  }
  
  setVw();
  window.addEventListener('resize', setVw);

// Tabs home Quick access
const pageHome = document.querySelector('.home');
if(pageHome){
    //Home tabs access
    let checkOne = document.getElementById('access__labelOne');
    let checkTwo = document.getElementById('access__labelTwo');

    let contentOne = document.querySelector('.access__list--one');
    let contentTwo = document.querySelector('.access__list--two');

    let buttonOne = document.querySelector('.access__btn--one');
    let buttonTwo = document.querySelector('.access__btn--two');
    
    contentOne.classList.add('js-selected');
    buttonOne.classList.add('js-selected');
    checkTwo.addEventListener('click',function(){
        contentOne.classList.remove('js-selected');
        buttonOne.classList.remove('js-selected');
        contentTwo.classList.add('js-selected');
        buttonTwo.classList.add('js-selected');
    })
    checkOne.addEventListener('click',function(){
        contentTwo.classList.remove('js-selected');
        buttonTwo.classList.remove('js-selected');
        contentOne.classList.add('js-selected');
        buttonOne.classList.add('js-selected');
    })
    
    //Home tabs dropdown keydown enter
    let inputOne = document.getElementById('access__btn--1');
    let inputTwo = document.getElementById('access__btn--2');
    inputOne.addEventListener('keydown',(e) =>{
        if (e.key === 'Enter') {
            contentTwo.classList.remove('js-selected');
            buttonTwo.classList.remove('js-selected', 'focus-active');
            contentOne.classList.add('js-selected');
            buttonOne.classList.add('js-selected', 'focus-active');
        }
    
    })
    inputTwo.addEventListener('keydown',(e) =>{
        if (e.key === 'Enter') {
            contentOne.classList.remove('js-selected');
            buttonOne.classList.remove('js-selected', 'focus-active');
            contentTwo.classList.add('js-selected');
            buttonTwo.classList.add('js-selected', 'focus-active');
        }
    })
}
  